import { FC } from 'react';
import { QuickSurveyQuestionBlockProps } from './quickSurvey.types';
import { QuickSurveyAnswerCards } from './QuickSurveyAnswerCards';
import { QuickSurveyAnswerSelect } from './QuickSurveyAnswerSelect';
import { MessagesTooltip } from 'components/feedback/MessagesTooltip';
import { InfoIcon } from 'components/icons/Icons';

const DEFAULT_DROPDOWN_THRESHOLD = 4;

export const QuickSurveyQuestionBlock: FC<QuickSurveyQuestionBlockProps> = ({
  question,
  selectedAnswerId,
  onSelect,
  dropdownThreshold = DEFAULT_DROPDOWN_THRESHOLD
}) => {
  const useDropdown = question.possibleAnswers.length > dropdownThreshold;

  // TODO: remove once the backend exposes a tooltip field on questions
  const questionTooltip: string | undefined =
    question.key === 'smoker'
      ? "Non-fumeur signifie que je ne fume pas ou que j'ai arrêté de fumer depuis plus de 24 mois."
      : undefined;

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center gap-1.5 mb-3">
        <label className="block text-sm font-medium text-gray-800">
          {question.label}
          {question.isRequired && <span className="text-red-500 ml-1">*</span>}
        </label>
        {questionTooltip && (
          <MessagesTooltip sections={[{ type: 'info', messages: [questionTooltip] }]}>
            <InfoIcon className="w-4 h-4 text-primary cursor-help" />
          </MessagesTooltip>
        )}
      </div>

      {useDropdown ? (
        <QuickSurveyAnswerSelect
          answers={question.possibleAnswers}
          selectedAnswerId={selectedAnswerId}
          onSelect={onSelect}
        />
      ) : (
        <QuickSurveyAnswerCards
          answers={question.possibleAnswers}
          selectedAnswerId={selectedAnswerId}
          onSelect={onSelect}
        />
      )}
    </div>
  );
};
